import { createSlice } from '@reduxjs/toolkit';

import { HOME_PATH, LOGIN_REQUIRED_PATH } from '~/routes/paths';

export type TLocationSliceType = {
  title: {
    mainView: string;
    dialogView: string;
  };
  routerPaths: {
    main: string;
    popup: string | undefined;
    menu: string | undefined;
  };
  previousPath: string | undefined;
  routeAfterLogin: string | undefined;
};

const INITIAL_STATE: TLocationSliceType = {
  title: {
    mainView: '',
    dialogView: '',
  },
  routerPaths: {
    main: HOME_PATH,
    popup: undefined,
    menu: undefined,
  },
  previousPath: undefined,
  routeAfterLogin: undefined,
};

const DEFAULT_TITLE = 'LootBoy';
const getDocumentTitle = (title: string) =>
  title ? `${DEFAULT_TITLE} - ${title}` : DEFAULT_TITLE;

const location = createSlice({
  name: 'location',
  initialState: INITIAL_STATE,
  reducers: {
    setMainViewTitle(state, { payload }: { payload: string }) {
      state.title.mainView = payload;
      document.title = getDocumentTitle(
        state.title.dialogView || state.title.mainView,
      );
    },
    setDialogTitle(state, { payload }: { payload: string }) {
      state.title.dialogView = payload;
      document.title = getDocumentTitle(
        state.title.dialogView || state.title.mainView,
      );
    },
    setMainPath(state, { payload }: { payload: string }) {
      state.routerPaths.main = payload;
    },
    setPopupPath(state, { payload }: { payload: string | undefined }) {
      state.routerPaths.popup = payload;
    },
    setMenuPath(state, { payload }: { payload: string | undefined }) {
      const { main, popup, menu } = state.routerPaths;
      if (payload === LOGIN_REQUIRED_PATH) {
        state.routeAfterLogin = menu || popup || main;
      }
      state.routerPaths.menu = payload;
    },
    setPreviousPath(state, { payload }: { payload: string }) {
      // to avoid setting `state.previousPath` on current path when hot reloading
      if (state.previousPath !== payload) {
        state.previousPath = payload;
      }
    },
    clearRouteAfterLogin(state) {
      state.routeAfterLogin = undefined;
    },
  },
  extraReducers: {
    LOGOUT_SUCCESSFUL(state) {
      state.routeAfterLogin = undefined;
    },
  },
});

export const {
  setMainViewTitle,
  setDialogTitle,
  setMainPath,
  setPopupPath,
  setMenuPath,
  setPreviousPath,
  clearRouteAfterLogin,
} = location.actions;

export const locationName = location.name;

export default {
  [location.name]: location.reducer,
};
